import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { updateComponent } from '../redux/editorSlice';
import { useTranslation } from '../redux/TranslationHelper';

function FAQComponent({ id, faqItems = [], title = "자주하는질문", style }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [expandedItems, setExpandedItems] = useState({});
  
  // 펼치기/접기 토글 함수
  const toggleItem = (index) => {
    setExpandedItems(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };
  
  // FAQ 항목 수정 함수
  const updateFAQItem = (index, field, value) => {
    const updatedItems = [...faqItems];
    updatedItems[index] = {
      ...updatedItems[index],
      [field]: value
    };
    
    dispatch(updateComponent({
      id,
      changes: { faqItems: updatedItems }
    }));
  };

  // 제목 수정 함수
  const updateTitle = (newTitle) => {
    dispatch(updateComponent({
      id,
      changes: { title: newTitle }
    }));
  };
  
  return (
    <div 
      className="faq-component" 
      style={{
        width: '100%',
        fontFamily: 'Arial, sans-serif',
        ...style
      }}
    >
      {/* FAQ 제목 영역 */}
      <h2 
        className="faq-title"
        style={{
          fontSize: (style?.titleStyle?.fontSize || '24px'),
          fontWeight: 'bold',
          marginBottom: '20px',
          textAlign: 'left',
          color: '#333',
          ...style.titleStyle
        }}
        onDoubleClick={() => {
          const newTitle = prompt(t('제목을 입력하세요:'), title);
          if (newTitle !== null) {
            updateTitle(newTitle);
          }
        }}
      >
        {typeof title === 'string' ? t(title) : title}
      </h2>
      
      {faqItems.map((item, index) => (
        <div 
          key={index} 
          className="faq-item"
          style={{
            marginBottom: '10px',
            border: '1px solid #e0e0e0',
            borderRadius: '8px',
            overflow: 'hidden',
          }}
        >
          <div 
            className="faq-question"
            onClick={() => toggleItem(index)}
            style={{
              padding: '15px 20px',
              backgroundColor: '#f8f8f8',
              color: '#333',
              fontWeight: 'bold',
              cursor: 'pointer',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <div 
              className="question-text"
              onDoubleClick={(e) => {
                e.stopPropagation();
                const newQuestion = prompt(t('질문을 입력하세요:'), item.question);
                if (newQuestion !== null) {
                  updateFAQItem(index, 'question', newQuestion);
                }
              }}
            >
              {typeof item.question === 'string' ? t(item.question) : (item.question || t('질문을 입력하세요'))}
            </div>
            <span style={{ transform: expandedItems[index] ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.3s ease' }}>
              ▼
            </span>
          </div>
          
          {expandedItems[index] && (
            <div 
              className="faq-answer"
              style={{
                padding: '15px 20px',
                backgroundColor: '#fff',
                color: '#555',
                lineHeight: '1.5',
              }}
              onDoubleClick={() => {
                const newAnswer = prompt(t('답변을 입력하세요:'), item.answer);
                if (newAnswer !== null) {
                  updateFAQItem(index, 'answer', newAnswer);
                }
              }}
            >
              {typeof item.answer === 'string' ? t(item.answer) : (item.answer || t('답변을 입력하세요'))}
            </div>
          )}
        </div>
      ))}
      
      
    </div>
  );
}

export default FAQComponent; 